import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


if ($('.logo-slider').length) {

	const attorneysSlider = new Swiper('.logo-slider .swiper', {
		loop: true,
		loopAdditionalSlides: 1,
		breakpoints: {
			480: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			640: {
				slidesPerView: 3,
				spaceBetween: 30
			},
			780: {
				slidesPerView: 4,
				spaceBetween: 40
			}
		 }
	});

	$('.logo-slider .next').on('click', function() {
		attorneysSlider.slideNext();
	});

	$('.logo-slider .prev').on('click', function() {
		attorneysSlider.slidePrev();
	});
}

